import { useState, useEffect, useRef } from 'react';

export default function Page({children, idx, currentIdx, setIndex, total}) {
    const [className, setClassName] = useState("page");
    const [style, setStyle] = useState({});
    const [rotation, setRotation] = useState(Math.random() * 8 - 4);
    const startXRef = useRef(null);
    const isFirstRender = useRef(true);

    const nextPage = () => {
        setIndex(prev => (prev > 0 ? prev - 1 : total - 1));
    }
    const prevPage = () => {
        setIndex(prev => (prev < total - 1 ? prev + 1 : 0));
    }

    const handlePointerDown = (e) => {
        startXRef.current = e.clientX ?? e.touches?.[0].clientX;
        window.getSelection().removeAllRanges();
    };

    const handlePointerUp = (e) => {
        if (startXRef.current == null) return;

        const endX = e.clientX ?? e.changedTouches?.[0].clientX;
        const deltaX = endX - startXRef.current;

        const threshold = 50; // minimum pixels to count as swipe
        if (deltaX > threshold) {
            nextPage();
        } else if (deltaX < -threshold) {
            prevPage();
        }

        startXRef.current = null; // reset
    };
    
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (idx === 0) {
                setClassName("page");
                setStyle({zIndex: 100});
            }
            return;
        }
        if (idx === currentIdx) {
            setClassName("page slide-forward");
            setRotation(Math.random() * 8 - 4);
            setStyle({
                zIndex: 0,
            });
            setTimeout(() => {
                setStyle(prev => ({
                    ...prev,
                    zIndex: 100,
                }));
            }, 250);
            setTimeout(() => {
                setClassName("page");
                setStyle(prev => ({
                    ...prev,
                }));
            }, 500);
        } else {
            setStyle({
                zIndex: 0,
                transform: `translate(-50%, 0) rotate(${rotation}deg)`
            });
        }
    }, [currentIdx]);


    return (
        <div className={className} style={style}>
            <div className="paperTex" onPointerDown={handlePointerDown} onPointerUp={handlePointerUp}></div>
            <div className="pageInnerWrap">
                {children}
            </div>
            <div className="pageNum">
                <div className="left" onClick={nextPage}>&larr;</div>
                <div>{idx + 1}</div>
                <div className="right" onClick={prevPage}>&rarr;</div>
            </div>
        </div>
    );
}